import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/courses.action'
import downloadCourses from '../../../api/courses/Download'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'
import { prepareSearch } from 'helpers/courseSearch.helper'

async function downloadCourse(allSelected: boolean, ids: any[], q: any) {
  return downloadCourses(allSelected, ids, q)
}

function* coursesDownloadEffectSaga(actions: any) {
  try {
    const { selectedRows, allSelected, params } = actions.payload
    const { searchText, usersFilter, fastFilters, areaId } = params

    const q = allSelected
      ? prepareSearch(searchText, usersFilter, fastFilters, areaId)
      : {}

    const { data } = yield call(downloadCourse, allSelected, selectedRows, q)
    yield put(fromActions.Actions.coursesDownloadSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.downSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.downloadError'))
    console.error(error)
  }
}

export function* coursesDownloadWatcherSaga() {
  yield takeLatest(fromActions.COURSES_DOWNLOAD, coursesDownloadEffectSaga)
}
